import styles from "./wizard.module.css"

import React from "react"
import cx from "classnames"
import merge from "lodash/merge"
import * as shared from "activities/components/shared"
import * as fonts from "shared/fonts"
import BackButtonSvg from "../../../images/back-button.svg?react"

const isStepActive = (idx, activeStep) => activeStep === idx

// Indicates whether a step was previously completed
const wasStepActive = (idx, activeStep) => activeStep > idx

const isLastStep = (steps, activeStep) => activeStep === steps.length - 1

export const StepIndicator = ({step, active, wasActive}) => <div className={cx(styles["number"], !active && styles["inactive"], wasActive && styles["completed"])} />

export const StepIndicators = ({steps, activeStep}) => (
  <div id="steps" className={styles["numbers"]}>
    {steps.map((step, idx) => (
      <StepIndicator key={idx} step={idx + 1} active={isStepActive(idx, activeStep) || wasStepActive(idx, activeStep)} wasActive={wasStepActive(idx, activeStep)} />
    ))}
  </div>
)

export const NextStepButton = ({steps, activeStep, onNextClick, onStartOverClick, text, isStepComplete}) => (
  <button
    className={cx(styles["next-button"], !isStepComplete && styles["disabled"], fonts.getFontClass())}
    onClick={isStepComplete ? (isLastStep(steps, activeStep) ? onStartOverClick : onNextClick) : null}
  >
    {text}
  </button>
)

const BackButton = ({onClick}) => {
  return (
    <button className={styles["button"]} onClick={onClick}>
      Back
    </button>
  )
}

const Step = (props) => {
  const {step, className} = props
  const subtitle = step.subtitle ? (
    typeof step.subtitle === "string" ? (
      <div className={cx(styles["subtitle"], fonts.getFontClass())}>{step.subtitle}</div>
    ) : (
      React.createElement(step.subtitle, props)
    )
  ) : null
  return (
    <shared.Content className={styles["content"]}>
      <h2 className={cx(styles["title"], fonts.getFontClass())}>{step.title}</h2>
      {subtitle}
      <div className={cx(styles["step"], className, step.stepStyles)}>{React.createElement(step.content, props)}</div>
    </shared.Content>
  )
}

export class Wizard extends React.Component {
  constructor(props) {
    super(props)
    this.state = {activeStep: 0}
    this.next = this.next.bind(this)
    this.startOver = this.startOver.bind(this)
    this.back = this.back.bind(this)
  }

  resetFocus() {
    document.getElementById("steps").focus()
  }

  componentDidUpdate(prevProps) {
    if (this.props.resetKey !== prevProps.resetKey) {
      this.setState({activeStep: 0})
    }
  }

  next() {
    const onChangeStep = this.props.setup.steps[this.state.activeStep].onChangeStep
    if (onChangeStep) {
      onChangeStep(this.props.setup.props.setState, this.props.setup.props)
    }
    this.setState({activeStep: this.state.activeStep + 1})
    this.resetFocus()
  }

  startOver() {
    if (this.props.onReset) {
      this.props.onReset()
    }
    this.setState({activeStep: 0})
    this.resetFocus()
  }

  back() {
    const onChangeStep = this.props.setup.steps[this.state.activeStep].onChangeStep
    if (onChangeStep) {
      onChangeStep(this.props.setup.props.setState, this.props.setup.props)
    }
    this.setState({activeStep: this.state.activeStep - 1})
    this.resetFocus()
  }

  render() {
    const {steps} = this.props.setup
    const {activeStep} = this.state
    const stepProps = this.props.setup.props
    return (
      <div id="wizard" className={styles["wizard"]}>
        <StepIndicators steps={steps} activeStep={activeStep} />
        <Step {...merge({}, stepProps, {steps: steps, step: steps[activeStep], className: this.props.className})} />
        {steps[activeStep].buttonText ? (
          <div className={styles["buttons"]}>
            {activeStep > 0 && <BackButton onClick={this.back} />}
            <NextStepButton
              steps={steps}
              text={steps[activeStep].buttonText}
              activeStep={activeStep}
              onNextClick={this.next}
              onStartOverClick={this.startOver}
              isStepComplete={steps[activeStep].isStepComplete(stepProps)}
            />
          </div>
        ) : null}
      </div>
    )
  }
}
